import { useFormContext } from 'react-hook-form';
import { DefaultAssetAllocationDTO } from '../../../../../../../../api/useAccountsOptionsQuery';
import { getWeightedAllocation } from '../../utils/getWeightedAllocation';
import { useSpecificPositions } from '../SpecificPositions/useSpecificPositions';
import { useNonSpecificPositions } from '../NonSpecificPositions/useNonSpecificPositions';
import { useAccountFormContext } from '../../../../context/useAccountFormContext';
import { AllocationTaxStatusDTO } from '../../../../../../../../api/useAccountsQuery';

interface UseAggregatedPositionsParams {
  assetAllocationTaxStatus: AllocationTaxStatusDTO | null;
}

export const useAggregatedPositions = ({
  assetAllocationTaxStatus,
}: UseAggregatedPositionsParams) => {
  const { watch } = useFormContext();

  const [accountType] = watch(['bankAccount.AccountType']);

  const {
    options: { DefaultAssetAllocation },
  } = useAccountFormContext();

  const { AssetAllocation: assetAllocationOptions } = DefaultAssetAllocation.find(
    defaults => defaults.AccountType === accountType,
  ) as DefaultAssetAllocationDTO;

  const { data: specificPositionsData } = useSpecificPositions({ assetAllocationTaxStatus });
  const { data: nonSpecificPositionsData } = useNonSpecificPositions({ assetAllocationTaxStatus });

  const allocations = [
    ...(specificPositionsData?.aggregatedPositions || []),
    ...(nonSpecificPositionsData?.aggregatedPositions || []),
  ];

  if (allocations.length === 0) {
    return {
      data: null,
    };
  }

  const weightedAllocation = getWeightedAllocation(allocations);

  const chartValues = assetAllocationOptions.map(asset => ({
    ...asset,
    y: weightedAllocation ? weightedAllocation[asset.id] * 100 : asset.y * 100,
  }));

  return {
    data: { chartValues },
  };
};
